import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd9c9686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { ref } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'primevue/usetoast'

import useClipboard from 'vue-clipboard3'

declare const gapi: any


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayStore',
  setup(__props) {

const store = useStore()
const toast = useToast()
const { toClipboard } = useClipboard()

const container = ref<HTMLElement>(null)
const packageName = ref<string>('')
const mcmId = ref<string>(null)

function isHttps(): boolean {
  return location.protocol === 'https:'
}

async function loadPlayStore(): Promise<void> {
  const { value } = await store.dispatch('createWebToken')
  const url = `https://play.google.com/work/embedded/search?token=${value}&mode=SELECT`

  gapi.load('gapi.iframes', () => {
    const options = {
      url,
      where: container.value,
      attributes: { style: 'width: 1000px; height:1000px', scrolling: 'yes' },
    }
    const iframe = gapi.iframes.getContext().openChild(options)
    iframe.register(
      'onproductselect',
      async function (event) {
        if (event.packageName?.length > 0) {
          try {
            await toClipboard(event.packageName)
            toast.add({
              severity: 'success',
              summary: 'Package name copied!',
              detail: event.packageName,
              life: 5000,
            })
          } catch (error) {
            console.error(error)
          }
        }
        console.log(event)
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    )
  })
}

async function loadManagedConfiguration() {
  const { value } = await store.dispatch('createWebToken')
  let url = `https://play.google.com/managed/mcm?token=${value}&packageName=${packageName.value}`

  if (mcmId.value) {
    url += `&mcmId=${mcmId.value}`
  }
  gapi.load('gapi.iframes', () => {
    const options = {
      url,
      where: container.value,
      attributes: { style: 'width: 1000px; height:1000px', scrolling: 'yes' },
    }
    const iframe = gapi.iframes.getContext().openChild(options)
    iframe.register(
      'onconfigupdated',
      function (event) {
        console.log(event)
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    )

    iframe.register(
      'onconfigdeleted',
      function (event) {
        console.log(event)
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    )
  })
}

return (_ctx: any,_cache: any) => {
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, { justify: "space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_DodoColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_DodoRow, { gap: "2" }, {
                default: _withCtx(() => [
                  isHttps
                    ? (_openBlock(), _createBlock(_component_DodoButton, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (loadPlayStore()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Load Play Store ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_InputText, {
                    modelValue: packageName.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((packageName).value = $event)),
                    placeholder: "Package Name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DodoColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_DodoRow, { gap: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: mcmId.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mcmId).value = $event)),
                    placeholder: "Managed Configuration Id (optional)"
                  }, null, 8, ["modelValue"]),
                  isHttps
                    ? (_openBlock(), _createBlock(_component_DodoButton, {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (loadManagedConfiguration()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Load Managed Configuration ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, {
        justify: "center",
        class: "store-wrapper"
      }, {
        default: _withCtx(() => [
          isHttps
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "container",
                ref: container
              }, null, 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, "Https (SSL) is required to load Play Store"))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})